import { Schemas } from '~/api/gen'
import { CloseButton } from '~/components/elements/CloseButton'
import { Img } from '~/components/elements/Img'
import { useAccessTokenValue } from '~/hooks/useAccessTokenValue'
import { useLoginMember } from '~/hooks/useLoginMember'
import fallbackIcon from '~/images/user_200.gif'
import { useComment } from '../hooks/useComment'
import { CommentList } from './CommentList'

type Props = {
  coordinate: Schemas.coordinate_large_with_member_shop_brands
  close: () => void
}

export const CommentOverlay: React.FC<Props> = ({ close, coordinate }) => {
  const { comments, restCommentsCount, hasMoreComments, totalCommentsCount } =
    useComment(coordinate.id)
  const accessToken = useAccessTokenValue()
  const { data: member } = useLoginMember(accessToken)
  const memberImage = member?.image.url_200
    ? member.image.url_200
    : fallbackIcon

  return (
    <div className="z-coordinateDetailUserComment min-h-screen">
      <div>
        <div className="px-[10px] pb-10 pt-5">
          <p className="text-[14px] font-bold leading-[1.3] text-black-400">
            {coordinate.member.nick_name}さんへのコメント ({totalCommentsCount})
          </p>
          {hasMoreComments && (
            <div className="mt-[13px]">
              <a
                href="wear2020://wear.jp/"
                className="text-[13px] font-bold leading-[1.8] text-blue-500"
              >
                他{restCommentsCount}
                件のコメントをアプリで表示
              </a>
            </div>
          )}
          <div className="pb-[46px]">
            {comments.length > 0 && (
              <CommentList
                memberId={coordinate.member.id}
                comments={comments}
              />
            )}
          </div>
        </div>
      </div>
      <div className="fixed bottom-0 flex w-full bg-white p-2 shadow-[0_0_10px_0_rgba(0,0,0,0.2)]">
        <p className="mt-[3px] size-[30px] overflow-hidden rounded-[50%] border border-gray-300">
          <Img src={memberImage} width={30} height={30} alt="" />
        </p>
        <p className="ml-2 flex-1">
          <a
            href={`wear2020://wear.jp/coordinate/${coordinate.id}/`}
            className="block rounded-[18px] border border-gray-300 bg-gray-100 py-2 pl-3 text-[14px] leading-[1.3] text-gray-500"
          >
            コメントをアプリで書く
          </a>
        </p>
      </div>
      <CloseButton
        onClick={close}
        className="fixed right-[15px] top-[15px] flex size-[30px] items-center justify-center rounded-[50%] bg-black text-[14px] leading-none text-white opacity-60"
      />
    </div>
  )
}
